export default __webpack_public_path__ + "static/media/info-help.81b40378.svg";